(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".product-acc-item");

  if (!items.length) return;

  /* ---- Open first accordion by default ---- */
  items[0].classList.add("active");
  const firstContent = items[0].querySelector(".product-acc-content");
  firstContent.style.maxHeight = firstContent.scrollHeight + "px";

  items.forEach(item => {
    const title = item.querySelector(".product-acc-title");
    const content = item.querySelector(".product-acc-content");

    title.addEventListener("click", () => {
      const isOpen = item.classList.contains("active");

      /* ---- Close all ---- */
      items.forEach(i => {
        i.classList.remove("active");
        i.querySelector(".product-acc-content").style.maxHeight = null;
      });

      /* ---- Open clicked one ---- */
      if (!isOpen) {
        item.classList.add("active");
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
